import { Link } from 'react-router-dom';
import { footerLinks, companyInfo } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-edit-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">{companyInfo.name}</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/50">{companyInfo.slogan}</p>
          </div>

          {Object.entries(footerLinks).map(([key, section]) => (
            <div key={key}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{section.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved. {companyInfo.icp}
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors duration-200" aria-label="WeChat">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors duration-200" aria-label="Weibo">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors duration-200" aria-label="GitHub">
              <i className="ri-github-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors duration-200" aria-label="Email">
              <i className="ri-mail-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}